import {Modal} from 'antd';
import styled from 'styled-components';
import {FC} from 'react';
import bg from '@/assets/popup-bg.jpg';

type Props = {
  visible: boolean;
  onClose: () => void;
  refresh?: () => void;
  title?: any;
  content?: any;
  footer?: any;
};
const Popup: FC<Props> = ({visible, onClose, title, content, footer}) => {
  return (
    <Container
      open={visible}
      centered
      onCancel={onClose}
      bodyStyle={{
        height: 328
      }}
      footer={footer ? footer : null}
      width="300px">
      {content && content}
    </Container>
  );
};

const Container = styled(Modal)`
  .ant-modal-close {
    top: -13px;
    right: -34px;
    color: #fef1c4;
    width: 30px;
    height: 30px;
    background: url(${require('@/assets/close.png')});
    background-size: 100% 100%;

    .ant-modal-close-x {
      display: none;
    }
  }
  .ant-modal-content {
    background: url(${bg});
    background-size: 100% 100%;
    .ant-modal-header {
      background: transparent;
      .ant-modal-title {
        text-align: center;
        height: 53px;
        font-size: 36px;
        font-family: 思源宋体;
        line-height: 60px;
        color: #a66121;
      }
    }
    .ant-modal-body {
      height: 243px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #8f5741;
      font-size: 20px;
    }
    .center {
      text-align: center;
      padding: 15px;
      font-family: '思源宋体-normal';
      height: 100%;
      img {
        object-fit: contain;
        height: 100%;
      }
    }
  }
`;

export default Popup;
